import React from 'react'
import PropTypes from 'prop-types'
// import { polyglot } from '../../../../index'
import './style.css'
import { Link } from 'react-router-dom'

export default class AgeGrid extends React.Component {
  render () {
    return (
      <ul className='age-grid'>
        {
          this.props.ages.map(function (currentValue, index) {
            let isSelected = false
            if (this.props.selectedAge && currentValue.url === this.props.selectedAge) {
              isSelected = true
            }
            return (<AgeCell isSelected={isSelected} url={currentValue.url} description={currentValue.text} key={index} age={currentValue} patientId={this.props.patientId} />)
          }.bind(this))
        }
      </ul>
    )
  }
}

AgeGrid.propTypes = {
  ages: PropTypes.arrayOf(PropTypes.shape({text: PropTypes.string.isRequired, url: PropTypes.string.isRequired})).isRequired,
  patientId: PropTypes.string.isRequired,
  selectedAge: PropTypes.string
}

const AgeCell = (props) => {
  return (
    <div className='col-xs-12 col-sm-4 col-md-4 no-side-padding padding-on-sm age-cell'>
      <Link
        to={{pathname: `/patients/${props.patientId}/consultations/${props.url}`}}>
        <div className={`thumbnail border-hover ${props.isSelected ? 'selected' : ''}`}>
          {/* <h4 className={`center hvr-bounce-in`}>{polyglot.t(props.description)}</h4> */}
          <h4 className={`center hvr-bounce-in`}>{props.description}</h4>
        </div>
      </Link>
    </div>
  )
}

AgeCell.propTypes = {
  url: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  patientId: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired
}



// WEBPACK FOOTER //
// ./src/components/general/Consultations/AgeGrid/AgeGrid.js